import React from 'react';
import { Button, Space, Typography } from 'antd';
import { Link } from 'react-router-dom';
import { useCookieConsent } from '../../hooks/useCookieConsent';

const { Text } = Typography;

const BRAND_INDIGO = '#2E2B81';

export const CookieBanner: React.FC = () => {
  const { showBanner, activePolicyVersion, acceptAll, acceptEssentialOnly } = useCookieConsent();

  if (!showBanner || !activePolicyVersion) return null;

  return (
    <div
      role="dialog"
      aria-label="Preferências de cookies"
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1100,
        background: '#fff',
        borderTop: `3px solid ${BRAND_INDIGO}`,
        padding: '20px 24px',
        boxShadow: '0 -4px 24px rgba(0,0,0,0.10)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: 16,
      }}
    >
      <Text style={{ flex: '1 1 300px', fontSize: 14, color: '#333', lineHeight: 1.6 }}>
        Usamos cookies essenciais para o funcionamento da plataforma e, opcionalmente, cookies de
        marketing (Google Tag Manager e Meta Pixel) para melhorar nossa comunicação.{' '}
        <Link to="/legal/politica-de-cookies" style={{ color: BRAND_INDIGO, fontWeight: 500 }}>
          Política de Cookies
        </Link>{' '}
        ·{' '}
        <Link to="/legal/politica-de-privacidade" style={{ color: BRAND_INDIGO, fontWeight: 500 }}>
          Política de Privacidade
        </Link>
      </Text>

      <Space wrap>
        <Button
          size="middle"
          onClick={() => acceptEssentialOnly(activePolicyVersion)}
          style={{ borderColor: BRAND_INDIGO, color: BRAND_INDIGO }}
        >
          Apenas essenciais
        </Button>
        <Button
          type="primary"
          size="middle"
          onClick={() => acceptAll(activePolicyVersion)}
          style={{ background: BRAND_INDIGO, borderColor: BRAND_INDIGO }}
        >
          Aceitar todos
        </Button>
      </Space>
    </div>
  );
};
